import React from "react";
import ReactDOMClient from "react-dom/client";
import '../../../utils/i18next';
import {PcWeb} from './pc/PcWeb'; // 注意这里是默认导入

const app = document.getElementById("root");
const root = ReactDOMClient.createRoot(app);
root.render(<PcWeb />);
